// extracted by mini-css-extract-plugin
export default {"rightSide":"style_rightSide__dVW0T"};